import { AxiosStatic } from "axios";
import { toCamel, toSnake } from "snake-camel";

export interface VehicleCategory {
  id?: number;
  name: string;
  vehicleTypeId?: number | null;
  vehicleType?: string | null;
}

export default ($axios: AxiosStatic) => ({
  async list(search: string | null = null): Promise<VehicleCategory[]> {
    const response = (
      await $axios.get("/api/vehicle-categories", { params: { search } })
    ).data.data;
    return response.map((row: any) => toCamel(row) as VehicleCategory);
  },

  async create(data: VehicleCategory): Promise<VehicleCategory> {
    const response = (
      await $axios.post("/api/vehicle-categories", toSnake(data))
    ).data.data;
    return toCamel(response) as VehicleCategory;
  },

  async update(id: number, data: VehicleCategory): Promise<VehicleCategory> {
    const response = (
      await $axios.put(`/api/vehicle-categories/${id}`, toSnake(data))
    ).data.data;
    return toCamel(response) as VehicleCategory;
  },

  async remove(id: number): Promise<void> {
    await $axios.delete(`/api/vehicle-categories/${id}`);
  }
});
